"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(payments) {
  var paymentMethod = payments.map(function (method) {
    return method.instrument;
  });

  if (paymentMethod.length > 1) {
    paymentMethod = paymentMethod.join(', ');
    return paymentMethod;
  }

  return paymentMethod[0];
};

exports["default"] = _default;